import { useEffect, useRef } from 'react';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PolarAreaController,
  ArcElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

interface Props {
  colors: string[];
  labels: string[];
  data: number[];
}

export const PolarChart: React.FC<Props> = ({ data, colors, labels }) => {
  const chartRef = useRef<HTMLCanvasElement>(null);

  ChartJS.register(
    RadialLinearScale,
    PolarAreaController,
    ChartDataLabels,
    ArcElement
  );

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext('2d');

      if (ctx) {
        const chartData: any = {
          labels: labels,
          datasets: [
            {
              data: data,
              borderWidth: 0,
              backgroundColor: colors,
            },
          ],
        };

        const options: any = {
          responsive: true,
          maintainAspectRatio: false,

          plugins: {
            datalabels: {
              display: false,
            },
            legend: { display: false },
          },
          scales: {
            r: {
              pointLabels: {
                display: true,
                centerPointLabels: true,
                color: (item: any) =>
                  chartData.datasets[0].backgroundColor[item.index],
                font: {
                  size: 12,
                  weight: 'bold',
                },
              },
              min: 0,
              grid: {
                color: '#F1F1F1',
                max: 5,
              },
              max: 5,
              ticks: {
                color: '#F1F1F1',
                showLabelBackdrop: false,
                stepSize: 1.0,
              },
            },
          },
        };

        // Create the polar chart
        const myChart = new ChartJS(chartRef.current, {
          type: 'polarArea',
          data: chartData,
          options: options,
        });

        // We need to destroy the reference to plot multiple graphs on the same page
        return () => {
          myChart.destroy();
        };
      }
    }
  }, [chartRef, data]);

  return (
    <div
      style={{
        width: '840px',
        maxHeight: '400px',
      }}
    >
      <canvas ref={chartRef}></canvas>
    </div>
  );
};
